import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Button } from '@revenuemarket/cds';
import { getTypographyCss, theme } from '@revenuemarket/design';

import { ModalAlertProps } from '../types/modal';

export const Wrapper = styled.div`
  width: 480px;
  padding: 24px;
  background: ${theme.colors.grayscale700};
  border: 1px solid ${theme.colors.grayscale600};
  border-radius: 4px;
  @media (max-width: 376px) {
    width: 100%;
  }
`;

export const Title = styled.h2`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  font-weight: 700;
  color: ${theme.colors.grayscale200};
  word-break: keep-all;
  ${getTypographyCss('h2')};
`;

export const TitleIcon = styled.div`
  display: flex;
  margin-right: 10px;
`;

export const Description = styled.p`
  margin-bottom: 16px;
  color: ${theme.colors.grayscale200};
  word-break: keep-all;
  ${getTypographyCss('body1')};
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 0 12px;
  justify-content: flex-end;
`;

export const ButtonModal = styled(Button)<Pick<ModalAlertProps, 'alertType'>>`
  ${({ alertType }) =>
    alertType === 'warning' &&
    css`
      background: #e99105;

      &:hover,
      &.pressed {
        background: #e99105;
      }
    `}
`;
